module.exports = __webpack_public_path__ + "static/media/2000R.684939d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/pure_tone/2000R.mp3
// module id = X/+x
// module chunks = 1